<template>
  <v-container>
    <v-card :loading="loading">
      <v-card-title>
        <v-subheader>
          <span class="title font-weight-normal">Fluxo de Contratos</span>
        </v-subheader>
        <v-spacer></v-spacer>
        <v-btn class="white--text mr-2" depressed color="#34bfa3" @click="$router.push('/contracts/new')">+ Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <ContractFlowTable title="Minhas atividades" :items="myContracts" :loading="loadingMyContracts"
              chip-color="primary" :user="user" button-label="Abrir" @open-contract="abrirContrato" />
          </v-col>

          <v-col cols="12" md="12">
            <ContractFlowTable
              :title="isUserEvaluator ? 'Atividades abertas em outras etapas' : 'Atividades abertas com avaliador'"
              :items="contractsToEvaluate" :loading="loadingContractsToEvaluate" chip-color="info" :user="user"
              button-label="Visualizar" @open-contract="abrirContrato" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ContractsService from "@/app/Services/ContractsService";
import ContractFlowTable from "./ContractFlowTable.vue";

const contractsService = ContractsService.build();

export default {
  name: "ContractFlow",
  components: { ContractFlowTable },
  data() {
    return {
      isUserEvaluator: false,
      myContracts: [],
      contractsToEvaluate: [],
      loadingMyContracts: false,
      loadingContractsToEvaluate: false,
      user: {},
      loading: false,
    };
  },
  mounted() {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (userData?.user) {
      this.user = userData.user;
    }
    this.fetchContratos();
  },
  methods: {
    async fetchContratos() {
      this.loading = true;
      const response = await contractsService.searchContractsByUser(this.user.CODUSU);
      this.isUserEvaluator = response.isUserEvaluator;
      this.myContracts = response.contracts.myContracts;
      this.contractsToEvaluate = response.contracts.contractsToEvaluate;
      this.loading = false;
    },
    abrirContrato(id, view) {
      this.$router.push({
        name: "ContractsEdit",
        params: { id, view, from: "flow" },
      });
    },
  },
};
</script>
